module.exports = __webpack_public_path__ + "img/lang_vi.3e8ce1ec.svg";